import { h } from 'preact';
import { USER_PLAY, USER_PLAY_PAUSEROLL } from '../../../../../types';
import { SKIP_BTN_LAYER } from '../../../../common/constants';
import { usePlayerContext, useStyles } from '../../../../common/hooks';
import { connect } from '../../../hoc';
import { LabeledButton } from '../../common';
import { PAUSEROLL_BTN_DEFAULT_COLOR_TV, PAUSEROLL_BTN_DEFAULT_COLOR_WEB, PAUSEROLL_BTN_FOCUS_COLOR_WEB, PAUSEROLL_BTN_HOVER_COLOR_WEB, PAUSEROLL_BTN_PLAY_STYLES } from './styles';

function PauserollResume({
  isTV,
  innerRef,
  style = {},
  disableFocus = false
}) {
  const player = usePlayerContext();
  const setStyles = useStyles();
  const customStyle = setStyles(PAUSEROLL_BTN_PLAY_STYLES);

  const customEnvStyle = isTV
    ? { backgroundColor: PAUSEROLL_BTN_DEFAULT_COLOR_TV }
    : { backgroundColor: PAUSEROLL_BTN_DEFAULT_COLOR_WEB };

  return (
    <div
      className="pauseroll-retake"
      type="button"
      style={{
        ...style,
        zIndex: SKIP_BTN_LAYER
      }}
      ref={innerRef}
    >
      <LabeledButton
        disableFocus={disableFocus}
        onClick={() => {
          player.userEvents$.next({ action: USER_PLAY_PAUSEROLL, source: USER_PLAY });
          player.play({ userGesture: true });
        }}
        icon="pauserollPlay"
        customStyle={{
          ...customStyle,
          ...customEnvStyle
        }}
        customActiveStyle={!isTV && {
          default: {
            // In LabeledButton, active = focus 🙃
            backgroundColor: PAUSEROLL_BTN_FOCUS_COLOR_WEB
          }
        }}
        customHoverStyle={!isTV && {
          default: {
            backgroundColor: PAUSEROLL_BTN_HOVER_COLOR_WEB
          }
        }}
        label="Reprendre la vidéo"
        ariaLabel="Fermer la publicité et reprendre la vidéo"
        iconSize={customStyle.iconSize}
      />
    </div>
  );
}

const selector = ({ media: { isTv } }) => ({ isTv });
export default connect(selector)(PauserollResume);
